import ReactGA from 'react-ga'

let useGoogleAnalytics = false

function initialize() {
  if (window.location.hostname === 'manuals.avantstay.com') {
    useGoogleAnalytics = true
    ReactGA.initialize('UA-115105293-4')
  }
}

function registerPageView() {
  if (useGoogleAnalytics) ReactGA.pageview(window.location.pathname + window.location.search)
}

function registerSectionOpening(sectionName: string) {
  if (useGoogleAnalytics)
    ReactGA.event({
      category: 'Manual',
      action: 'OpenSection',
      label: sectionName,
    })
}

export const Tracker = {
  initialize,
  registerPageView,
  registerSectionOpening,
}
